import React from "react";
import { ClipLoader } from "react-spinners";

function Loading({ color = "#000000", style }) {
  return (
    <div className="contentWrap">
      <div
        style={
          style
            ? style
            : {
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }
        }
      >
        <ClipLoader color={color} height={15} width={5} radius={2} margin={2} />
      </div>
    </div>
  );
}

export default Loading;
